import * as React from 'react'

import Sidebar from '@frontrow/console/src/components/common/dashboard/sidebar'
import * as style from './dashboard.module.scss'

type Props = {
  children: React.ReactElement
}

export default function Dashboard(props: Props): React.ReactElement {
  const {children} = props

  return (
    <div>
      <Sidebar />
      <div className={style.dashboardMainContentWrapper}>
        <div className={`pt-2 ${style.dashboardMainContent}`}>{children}</div>
      </div>
    </div>
  )
}
